import React, { useCallback, useEffect, useState } from 'react'
import { nineBoxCompetenceTranslate } from '../../i18n/translatedMessages'
import { HiClipboardDocumentList, HiFlag, HiMiniUser, HiMiniUserGroup } from 'react-icons/hi2'
import { translate as translateDimensions } from '../../i18n/Library/dimensionsWitMeGrow.js'
import { useIntl } from 'react-intl'

const assets = {
	Organizacional: {
		'small-icon': <HiClipboardDocumentList />,
		icon: <HiClipboardDocumentList size={28} />,
		color: '#008ACD',
		subColor: '#79bad9',
	},
	Persona: {
		'small-icon': <HiMiniUser />,
		icon: <HiMiniUser size={28} />,
		color: '#D87706',
		subColor: '#edbf8a',
	},
	Líder: {
		'small-icon': <HiFlag />,
		icon: <HiFlag size={28} />,
		color: '#00A28B',
		subColor: '#75c7bb',
	},
	Social: {
		'small-icon': <HiMiniUserGroup />,
		icon: <HiMiniUserGroup size={28} />,
		color: '#6C4FDB',
		subColor: '#9d8cdb',
	},
}

export function EmployeeCompetenceView({ mergedCompetence }) {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	return (
		<table className='tw-min-w-full tw-border-separate tw-border-spacing-y-3'>
			<thead>
				<tr>
					<th className='tw-text-left tw-font-bold tw-text-black tw-text-base'>{nineBoxCompetenceTranslate.competenceAvaliationLabel}</th>
					<th className='tw-text-right tw-font-bold tw-text-black tw-text-base tw-pr-5'>{nineBoxCompetenceTranslate.scoreTitle}</th>
				</tr>
			</thead>
			{mergedCompetence.map((dimension, index) => {
				const barColor = assets[dimension.title]?.color || '#000000'
				const subBarColor = assets[dimension.title]?.subColor || '#000000'

				const translatedDimensionTitle = translateDimensions[language][dimension.title] || dimension.title

				const translatedItems = dimension.items.map(item => ({
					...item,
					translatedTitle: translateDimensions[language][item.title] || item.title,
				}))

				return (
					<tbody key={index} className='tw-mb-5 tw-pb-5'>
						<tr className='tw-bg-gray-100 tw-mb-5'>
							<td className='tw-text-left tw-py-2 tw-pl-5 tw-font-semibold' style={{ color: barColor }}>
								{translatedDimensionTitle}
							</td>
							<td className='tw-text-right tw-py-2 tw-pr-5  tw-text-white' style={{ color: barColor }}>
								{dimension.score_relative}%
							</td>
						</tr>
						{translatedItems
							.filter(item => item.score !== null && item.score !== '')
							.map((item, itemIndex) => (
								<tr key={itemIndex} className='tw-bg-white tw-rounded-lg tw-shadow-sm'>
									<td className='tw-text-left tw-pl-5 tw-py-2 tw-text-black tw-text-sm'>{item.translatedTitle}</td>
									<td className='tw-text-right tw-py-2 tw-pr-5 tw-text-sm tw-text-black'>{item.score * 5}%</td>
								</tr>
							))}
					</tbody>
				)
			})}
		</table>
	)
}
